import { css } from '../../styles/theme';
import { IButtonStyles } from '../Button/ButtonStyled';
import { rem } from 'polished';

export const StylesDS = css<IButtonStyles>`
    width: ${rem(240)};
    height: ${rem(42)};

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.white};
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.default};
            border: 1px solid ${({ theme }) => theme.colors.default};
            opacity: 0.25;
        `}
`;
